import * as React from 'react';
import { Drawer, Button, Input, Select, Col, Row, Form, Icon, Divider, Descriptions } from 'antd';
import FormControl from "components/Forms/FormControl";
import { FormComponentProps } from "antd/lib/form";
import { IAddTrackedBolRequestModel, TrackedBolStatus, AddTrackedBolRequestModel, ITrackedBolFileModel, TrackedBolFileType, ITrackedBolFileType, TrackedBolServiceCategory } from "Core/Api/Kopp/Api";
import { BolFilesEditor } from "components/Forms/BolFilesEditor";
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { TrackedBolSupplementaryInfoFormHandler } from './TrackedBolSupplementaryInfoFormHandler';
import SimpleSelect from 'components/Forms/SimpleSelect';
import AuthContext from 'Context/AuthContext';
import ISelectOption from 'components/Forms/SimpleSelect/ISelectOption';
import NotificationUtility from 'Core/NotificationUtility';
import ValidationUtility from 'Core/ValidationUtility';
import Utility from 'Core/Utility';
import { SubmitButton } from 'components/SubmitButton';
import _ from 'lodash';

export interface Props extends FormComponentProps, RouteComponentProps {
    children?: React.ReactNode
    drawerVisible: boolean;
    readonly?: boolean;
    trackedBol?: IAddTrackedBolRequestModel;
    onComplete: (value: IAddTrackedBolRequestModel) => void;
    onCancel?: () => void;
}

export interface State {
    tarriffCodeDescriptions?: ISelectOption[];
    filteredTarriffCodeDescriptions?: ISelectOption[];
    maskClosable: boolean;
    fileTypes?: ITrackedBolFileType[];
}

class BaseTrackedBolSupplementaryInfoForm extends React.Component<Props, State> {
    handler: TrackedBolSupplementaryInfoFormHandler;
    static contextType = AuthContext;
    context!: React.ContextType<typeof AuthContext>;

    constructor(props: Props) {
        super(props)
        this.handler = new TrackedBolSupplementaryInfoFormHandler(props);

        this.state = {
            maskClosable: false,
        }
    };

    componentDidMount = () => {
        this.getTariffCodeDescription();
        this.props.form.setFieldsValue(this.props.trackedBol ?? {});
        this.getTrackedBolFileTypes();
    }

    handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        this.props.form.validateFieldsAndScroll((error, values: IAddTrackedBolRequestModel) => {
            if (!error) {

                //TODO: might create a model for just the supplemenatary info
                let trackedBolWithSupplementaryinfo: IAddTrackedBolRequestModel = new AddTrackedBolRequestModel();
                trackedBolWithSupplementaryinfo = {
                    value: values.value,
                    tariffCodeDescriptionIds: values.tariffCodeDescriptionIds,
                    bolFiles: values.bolFiles,
                    serviceCategory: values.serviceCategory
                };
                this.props.onComplete({ ...this.props.trackedBol, ...trackedBolWithSupplementaryinfo });

            }
        })

    };

    getTariffCodeDescription = () => {
        return this.handler.GetTrackedBolDesciptions().then(x => {
            let tariffCodeDescriptions: ISelectOption[] =
                x.results?.map(y => ({
                    text: y.name!,
                    value: y.id!,
                })) ?? [];
            let otherOption = tariffCodeDescriptions.filter(x => x.text?.toString().toLowerCase() == "other")?.pop();
            tariffCodeDescriptions = tariffCodeDescriptions.filter(x => !(x.text?.toString().toLowerCase() == "other"));
            if (otherOption && tariffCodeDescriptions) {
                tariffCodeDescriptions.push(otherOption);
            }
            this.setState({ tarriffCodeDescriptions: tariffCodeDescriptions, filteredTarriffCodeDescriptions: tariffCodeDescriptions });
        })
    };

    getTrackedBolFileTypes = () => {
        this.handler.GetBolFileTypes().then(x => {
            const fileTypes: ITrackedBolFileType[] =
                x.results?.map(y => ({
                    id: y.id!,
                    name: y.name!,
                })) ?? [];
            this.setState({ fileTypes });
        })
    };

    isUserIdFileUploaded = (files: ITrackedBolFileModel[]) => {

        let uploadedFilesTypes: ITrackedBolFileType[] = [];

        //match all uploaded file with a fileType
        for (var i = 0; i < files.length; ++i) {
            let match = this.state.fileTypes?.find(x => x.id == files[i].bolFileTypeId);
            uploadedFilesTypes.push(match!);
        }

        //return true if fileType of any identification exists      
        return uploadedFilesTypes.some(x => {
            if (x.name == "Drivers Licence" || x.name == "National ID" || x.name == "Passport") {
                return true;
            }
            else {
                return false;
            }
        })
    };

    onCancel = (e) => {
        this.props.onCancel?.call(this);
    }

    drawerHeader = (
        <Row>
            <Col>
                {/* <Row style={{ margin: "-10px -30px 10px -24px", background: "#f8f8f8", padding: "10px 10px 15px 24px" }}>
                    <Col>{`Details for BL# ${this.props.trackedBol?.bolNumber?.toUpperCase()}`}</Col>
                </Row>
                <Row style={{ marginBottom: "5px" }}>
                    <Col span={6}>{`BL#: `}</Col>
                    <Col>{`${this.props.trackedBol?.bolNumber?.toUpperCase()}`}</Col>
                </Row>
                <Row style={{ marginBottom: "5px" }}>
                    <Col span={6}>{`Vessel Name: `}</Col>
                    <Col>{`${this.props.trackedBol?.vessel}`}</Col>
                </Row>
                <Row>
                    <Col span={6}>{`Arrival Date: `}</Col>
                    <Col>{`${Utility.ToDateTimeString(this.props.trackedBol?.arrivalDate!)}`}</Col>
                </Row>
                <Row>
                    <Col span={6}>{`Shipper/Agent Name: `}</Col>
                    <Col>{this.props.trackedBol?.shipperName}</Col>
                </Row>
                <Row>
                    <Col span={6}>{`Consignee Name: `}</Col>
                    <Col>{this.props.trackedBol?.consigneeName}</Col>
                </Row>
                <Row>
                    <Col span={6}>{`Description of Cargo: `}</Col>
                    <Col>{this.props.trackedBol?.cargoDescription}</Col>
                </Row> */}

                <Descriptions bordered={false} column={1} title={<div style={{background: "#f8f8f8", padding: "10px 10px 15px 24px"}} >Details for BL# {this.props.trackedBol?.bolNumber?.toUpperCase()}</div>}>
                    <Descriptions.Item label="BL#" >{this.props.trackedBol?.bolNumber?.toUpperCase()}</Descriptions.Item>
                    <Descriptions.Item label="Vessel Name" >{this.props.trackedBol?.vessel}</Descriptions.Item>
                    <Descriptions.Item label="Arrival Date" >{Utility.ToDateTimeString(this.props.trackedBol?.arrivalDate!)}</Descriptions.Item>
                    <Descriptions.Item label="Shipper/Agent Name" >{this.props.trackedBol?.shipperName}</Descriptions.Item>
                    <Descriptions.Item label="Consignee Name" >{this.props.trackedBol?.consigneeName}</Descriptions.Item>
                    <Descriptions.Item label="Description of Cargo" >{this.props.trackedBol?.cargoDescription}</Descriptions.Item>
                </Descriptions>
            </Col>
        </Row>
    );

    filterTarriffCodes = (filter: string) => {
        var newFilter = this.state.tarriffCodeDescriptions?.filter(x => x.text?.toString().toLocaleLowerCase().includes(filter?.toLowerCase())) ?? this.state.tarriffCodeDescriptions;
        this.setState({ filteredTarriffCodeDescriptions: newFilter });
    }

    render() {

        const { Option } = Select;
        const serviceCategory = (
            <Select>
                {Utility.enumToSelectionOptionArray(TrackedBolServiceCategory).map(category => (
                    <Option key={category.text} value={category.value}>
                        {_.startCase(category.value)}
                    </Option>
                ))}
            </Select>
        );

        const { getFieldDecorator } = this.props.form;
        return (

            <Drawer
                title={this.drawerHeader}
                placement="right"
                maskClosable={this.state.maskClosable}
                visible={this.props.drawerVisible}
                destroyOnClose={true}
                closable={true}
                width={"35%"}
            >
                <Form onSubmit={this.handleSubmit}>
                    <FormControl
                        getFieldDecorator={getFieldDecorator}
                        rules={[]}
                        // label="Uploud File Here:"
                        initialValue={this.props.trackedBol?.bolFiles}
                        // help={<i>Scanned Copy of National ID is required</i>}
                        labelAlign="left"
                        name="bolFiles">
                        <BolFilesEditor />
                    </FormControl>
                    <FormControl
                        getFieldDecorator={getFieldDecorator}
                        rules={[]}
                        label="Description:"
                        labelAlign="left"
                        initialValue={this.props.trackedBol?.tariffCodeDescriptionIds}
                        name="tariffCodeDescriptionIds">
                        <SimpleSelect mode="multiple" onSearch={this.filterTarriffCodes} filterOption={false} options={this.state.filteredTarriffCodeDescriptions} />
                    </FormControl>
                    <FormControl
                        getFieldDecorator={getFieldDecorator}
                        rules={[{ pattern: /^\$?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[0-9][0-9])?$/, message: 'Please enter valid currency' }]}
                        initialValue={this.props.trackedBol?.value}
                        label="Value:"
                        labelAlign="left"
                        name="value"
                        style={{ width: '60%' }}
                    >
                        <Input prefix='$' placeholder="Enter Value" />
                    </FormControl>
                    <FormControl
                        getFieldDecorator={getFieldDecorator}
                        label="Service Category"
                        labelAlign="left"
                        initialValue={this.props.trackedBol?.serviceCategory}
                        name="serviceCategory">
                        {serviceCategory}
                    </FormControl>
                    {!this.props.readonly ?
                        <Row>
                            <Col span={5} >
                                <Form.Item>
                                    <SubmitButton type="primary" htmlType="submit" style={{ textAlign: "center" }}>Submit</SubmitButton>
                                </Form.Item>
                            </Col>
                            <Col span={3}>
                                <Form.Item>
                                    <Button type="danger" onClick={this.onCancel} style={{ textAlign: "center" }}>Cancel</Button>
                                </Form.Item>
                            </Col>
                        </Row>
                        :
                        null
                    }
                </Form>
            </Drawer>
        )
    }
}

const TrackedBolSupplementaryInfoFormWithoutRouter = Form.create<Props>({
    name: 'TrackedBolSearchBar',
})(BaseTrackedBolSupplementaryInfoForm);

const TrackedBolSupplementaryInfoForm = withRouter(TrackedBolSupplementaryInfoFormWithoutRouter)
export default TrackedBolSupplementaryInfoForm;
